import { getSharedVariables } from "@entrilia/shared/variables";
import type { ReportUsage } from "../../../../../../api/types/svTypes";
import { pageRoutes } from "../../../../../../routes";

export const getUiReportsUrl = (clientCode: string) => {
  return `/${clientCode}/${pageRoutes.smartViews}/${pageRoutes.companyReports}`;
};
export const getApiReportsUrl = (clientCode: string) => {
  return `/${clientCode}/${pageRoutes.smartViews}/${pageRoutes.apiReports}`;
};
export const getSystemReportsUrl = (clientCode: string) => {
  return `/${clientCode}/${pageRoutes.smartViews}/${pageRoutes.systemReports}`;
};
export const getOrganizationReportTemplatesUrl = (organization: string) => {
  return `/${organization}/${pageRoutes.smartViews}/${pageRoutes.reportTemplates}`;
};
export const getCreateReportUrl = (clientCode: string) => {
  return `${getUiReportsUrl(clientCode)}/create`;
};
export const getEditUiReportUrl = (clientCode: string, reportId: string) => {
  return `${getUiReportsUrl(clientCode)}/${reportId}/edit`;
};
export const getViewUiReportUrl = (clientCode: string, reportId: string) => {
  return `${getUiReportsUrl(clientCode)}/${reportId}/view`;
};
export const getEditApiReportUrl = (clientCode: string, reportId: string) => {
  return `${getApiReportsUrl(clientCode)}/${reportId}/edit`;
};
export const getViewApiReportUrl = (clientCode: string, reportId: string) => {
  return `${getApiReportsUrl(clientCode)}/${reportId}/view`;
};
export const getEditSystemReportUrl = (clientCode: string, reportId: string) => {
  return `${getSystemReportsUrl(clientCode)}/${reportId}/edit`;
};
export const getViewSystemReportUrl = (clientCode: string, reportId: string) => {
  return `${getSystemReportsUrl(clientCode)}/${reportId}/view`;
};
export const getEditReportTemplateUrl = (organization: string, dataSource: string, templateId: string) => {
  return `/${dataSource}/${pageRoutes.smartViews}/${pageRoutes.reportTemplates}/${organization}/${templateId}/edit`;
};
export const getApplyTemplateUrl = (clientCode: string, reportId: string, templateId: string) => {
  return `${getEditUiReportUrl(clientCode, reportId)}?templateId=${templateId}`;
};
export const versionHistoryQueryParamKey = "versionHistory";
export const withVersionHistoryParam = (editReportUrl: string): string => {
  return `${editReportUrl}?${versionHistoryQueryParamKey}=true`;
};
export const getRunPublicApiReportUrl = () => {
  return `${getSharedVariables().PORTAL_BACKEND_BASE_URI}/reports/Public/run`;
};

export const getViewReportUrl = (reportUsage: ReportUsage): ((clientCode: string, reportId: string) => string) => {
  switch (reportUsage) {
    case "Ui":
      return getViewUiReportUrl;
    case "Api":
      return getViewApiReportUrl;
    case "System":
      return getViewSystemReportUrl;
    default:
      throw new Error(`Unsupported report usage: ${reportUsage}`);
  }
};
